import { Pipe, PipeTransform } from '@angular/core';
import { Visits } from "@types-lib";
import { isObject } from "lodash";

@Pipe({
	name: 'fullname',
	standalone: true,
})
export class FullnamePipe implements PipeTransform {
	transform(user: Visits.User): unknown {
		if (!isObject(user)) {
			return user;
		}
		if(user.name) {
			return user.name;
		} else {
			return `${user.firstname} ${user.lastname}`;
		}
	}
}
